const config = {
  set_title: '版面设置',
  set_tip: '用户可透过使用习惯修改此页面需要显示的资料',
  save_btn: '储存',
  data_id: '申请编号',
  data_group: '小组',
  date: '日期',
  data_address: '面试地点',
  data_parents_info: '家长资料',
  data_birth: '出生证明',
  data_receipt: '收据',
  data_parents_contact: '家长联络资料',
  data_time: '面试时段',
  data_date: '面试日期',
  data_rating: '评分情况',
  data_attendance: '出席情况',
  table_title: '查询申请资料',
  table_btn: '版面设置',
  table_search_student: '搜索面试学生',
  table_search_date: '面试日期',
  table_search_timeFrame: '面试时段',
  table_search_place: '面试地点',
  data_name: '姓名',
  data_interview_no: '面试编号',
  data_sex: '性別',
  data_operation: '操作',
  open_btn: '打开',
  edit_btn: '更改资料',
  phase: '请选择面试阶段',
  Name_interview: '面试名称',
  group: '面试组别',
  previous: '取消',
  determine: '确定',
  interview_system: '面试系统',
  NameofStudent: '学生姓名',
  Confirm_attend: '确认出席',
  Application_number: '申请编号',
  interview_panel: '面试小组',
  interview_time: '面试时间',
  select_time: '选择时间',
  returns: '返回',
  attendance: '出席',
  Parent_Contact_Number: '家长联系电话',
  birth_certificate: '出生证明',
  open: '打开',
  receipt: '收据',
  attend_time: '出席时间',
  name: '名称：',
  telephone: '联络电话：',
  FATHER: '父亲',
  MOTHER: '母亲',
  GUARDIAN: '监护人',

  select_view_time: '选择面试时间',
  selected: '已选择',
  confirm_time: '确认',

  not_info: '暂时没有资料',
  not_device: '找不到设备,请使用相册功能',
  Cancel_attendance: '取消出席',
  Cancellation_succeeded: '取消成功',
  Cancel_failed: '取消失败',
  Success_attend: '成功出席',
  Attend_failed: '出席失败',
  location: '面试地点',
  total_score: '总分',

  Scan_successfully: '扫码成功,正在前往',
  Scan_loading: '正在加载，请稍后...',
  Scan_failed: '读取失败,请重试',
  Scan_error: '该二维码不在此面试阶段',
  Invalid_token: 'token错误,请重试',
  Incorrect_QR_code: '二维码不正确',
  employee: '{{value}}是PLK员工吗?',
  graduate: '{{value}}是PLK毕业生吗?',
  WorkPlace: '工作场所',
  NameEnglish: '英文名称：',
  career: '职业：',
  Yes: '是',
  no: '否',
  Parent: '家长',
  Setscore: '评分',
  Attend: '是否出席',
  not_found: '没有资料',
  ConnectPrinter: '连接打印机',
  PrintLabel: '打印Label',
  logout: '登出',
  preview: '预览',
  student_file: '学生档案',
  Row: '第 {{from}} 项至第 {{to}} 项, 共 {{ value }} 项 ',
  Page: '每页行数: ',
  attendance_status: '出席状态',
  not_present: '未出席',
};

export default config;
